import { Component, OnInit } from '@angular/core';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { fuseAnimations } from '../../../../../../core/animations';
import { TranslationService } from '../../../../../services/translation/translation.service';
import { SweetAlertService } from '../../../../../services/sweet-alert/sweet-alert.service';
import { ReportConfigurationService } from '../../../../../services/report-configuration/report-configuration.service';
import { ReportConfiguration } from '../../../../../models/report-configuration/report-configuration';

@Component({
    selector: 'report-configuration',
    templateUrl: './report-configuration.component.html',
    styleUrls: ['./report-configuration.component.scss'],
    animations: fuseAnimations
})
export class ReportConfigurationComponent implements OnInit {
    @BlockUI() blockUI: NgBlockUI;
    public config = new ReportConfiguration();

    constructor(
        private translationService: TranslationService,
        private sweetAlertService: SweetAlertService,
        private reportConfigurationService: ReportConfigurationService
    ) {
    }

    ngOnInit() {
        this.blockUI.start(this.translationService.loading);
        this.reportConfigurationService.get().subscribe((config) => {
            this.config = config;
            this.blockUI.stop();
        }, error => {
            this.blockUI.stop();
            this.translationService.translate('ERRORS.ERROR_REQUEST', error, (res: string) => {
                this.sweetAlertService.error('Error', res, null);
            });
        });
    }

    save() {
        this.blockUI.start(this.translationService.savingChanges);
        this.reportConfigurationService.edit(this.config).subscribe(response => {
            this.blockUI.stop();
            if (response.ResultCode === 1) {
                this.translationService.translate('LABELS.SUCCESS_REQUEST', '', (res) => {
                    this.sweetAlertService.success(this.translationService.success, res, null);
                });
            } else {
                this.translationService.translate('ERRORS.ERROR_REQUEST', response.resultMsg, (res: string) => {
                    this.sweetAlertService.error('Error', res, null);
                });
            }
        }, error => {
            this.blockUI.stop();
            this.translationService.translate('ERRORS.ERROR_REQUEST', error, (res: string) => {
                this.sweetAlertService.error('Error', res, null);
            });
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/main/content/pages/management/configurations/report-configuration/report-configuration.component.ts